import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    permissions: [],
};

export const PermissionSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        getUserPermissions: (state, action) => {
            state.permissions = action.payload;
        },
    }
})

export const { getUserPermissions } = PermissionSlice.actions;

export default PermissionSlice.reducer;